import { render, staticRenderFns } from "./BoxInfo.vue?vue&type=template&id=35cd1778&scoped=true&"
import script from "./BoxInfo.vue?vue&type=script&lang=js&"
export * from "./BoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./BoxInfo.vue?vue&type=style&index=0&id=35cd1778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd1778",
  null
  
)

export default component.exports